import { useState, useEffect } from "react";
import "./Report.css";
import "./Table.css";
import API_URL from "../Config";
import axiosInstance from "../axiosinstance";
import "antd/dist/reset.css";
import { AlertTriangle, Boxes, Group, MapPin, SlidersHorizontal } from "lucide-react";
import { Snackbar, Alert as MuiAlert } from "@mui/material";
import { useCallback } from "react";
import { TbReportAnalytics } from "react-icons/tb";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Typography,
  Paper,
  TextField,
} from "@mui/material";
import { TbReport } from "react-icons/tb";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Loader from "../Components/Loader";
import PaginationFooter from "../Components/PaginationFooter.js";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { RiFileExcel2Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";


function AllTags({ isSidebarExpanded }) {
  const [selectedReport, setSelectedReport] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]); // API result
  const [reportSubmitted, setReportSubmitted] = useState(false);
  const [showDropdown, setShowDropdown] = useState(true); // controls dropdown visibility
  const [reportData, setReportData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [fieldDefinitions, setFieldDefinitions] = useState([]);
  
  //Search
  const [searchEquipment, setSearchEquipment] = useState("");
  const [selectAll, setSelectAll] = useState(false);

  // group report
  const [showGroupPopup, setShowGroupPopup] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);

  const [reportType, setReportType] = useState("");

  // Area report
  const [searchValue, setSearchValue] = useState("");
  const [searchType, setSearchType] = useState("contains");
  const [positionStart, setPositionStart] = useState("");
  const [positionEnd, setPositionEnd] = useState("");
  const [showAreaPopup, setShowAreaPopup] = useState(false);

  // custom report
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [filterValue, setFilterValue] = useState(""); // current value being added
  const [customFilters, setCustomFilters] = useState({}); // structure: { field: [values] }

  const [selectedField, setSelectedField] = useState(""); // current field being added
  const [headerOptions, setHeaderOptions] = useState([]);

  const [searchGroup, setSearchGroup] = useState("");
  const [selectAllGroups, setSelectAllGroups] = useState(false);

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [debouncedSearchGroup, setDebouncedSearchGroup] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchEquipment);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchEquipment]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearchGroup(searchGroup), 500);
    return () => clearTimeout(t);
  }, [searchGroup]);

  useEffect(() => {
    if (!showCustomPopup) return;

    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    if (!selectedProject || selectedProject.length === 0) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);
    axiosInstance
      .get("/api/get_custom_selection_list", {
        params: { project_selected: selectedProject },
      })
      .then((res) => {
        if (Array.isArray(res.data.fields)) {
          setHeaderOptions(res.data.fields);
          setFieldDefinitions(res.data.fields);
        } else {
          setHeaderOptions([]);
          setFieldDefinitions([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch header options:", err);
      })
      .finally(() => setLoading(false));
  }, [showCustomPopup]);

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      const allEquipmentNumbers = equipmentList.map(
        (item) => item.equipment_number
      );
      setSelectedEquipments(allEquipmentNumbers);
    } else {
      setSelectedEquipments([]);
    }
  };

  const handleSelectAllGroups = (checked) => {
    setSelectAllGroups(checked);
    if (checked) {
      setSelectedGroups(groupList.map((g) => g.group_name));
    } else {
      setSelectedGroups([]);
    }
  };

  const formatKeyLabel = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const [filterFields, setFilterFields] = useState([]);

  const addFilterField = () => {
    setFilterFields([...filterFields, { key: "", op: "", value: "" }]);
  };

  // Helper function to get field definition
  const getFieldDefinition = (fieldKey) => {
    return fieldDefinitions.find((field) => field.key === fieldKey);
  };

  // add near your other helpers
  const getOpsForField = (key) => getFieldDefinition(key)?.operators ?? [];

  const handleopChange = (index, nextOp) => {
    const updated = [...filterFields];
    const prevOp = updated[index].op;
    updated[index].op = nextOp;

    // Clear value when switching to or from 'between'
    if (nextOp === "between" || prevOp === "between") {
      updated[index].value = "";
    }
    setFilterFields(updated);
  };

  // Helper function to get op display name
  // const getopDisplayName = (op) => {
  //   const opMap = {
  //     equals: "Equals (=)",
  //     not_equals: "Not Equals (!=)",
  //     contains: "Contains",
  //     starts_with: "Starts With",
  //     ends_with: "Ends With",
  //     "=": "Equals (=)",
  //     "!=": "Not Equals (!=)",
  //     ">": "Greater Than (>)",
  //     ">=": "Greater Than or Equal (>=)",
  //     "<": "Less Than (<)",
  //     "<=": "Less Than or Equal (<=)",
  //     between: "Between",
  //   };
  //   return opMap[op] || op;
  // };

  const titleCase = (s = "") =>
    s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const getOperatorLabel = (op) => {
    if (!op || typeof op !== "string") return "";
    return /^[=<>!]+$/.test(op) ? op : titleCase(op);
  };

  const validateFilterValue = (fieldKey, op, value) => {
    const fieldDef = getFieldDefinition(fieldKey);

    if (!value || String(value).trim() === "") {
      return { isValid: false, message: "Value is required" };
    }

    if (fieldDef && fieldDef.dataType === "number") {
      if (op === "between") {
        const parts = String(value)
          .split("-")
          .map((v) => v.trim())
          .filter(Boolean);
        if (parts.length !== 2) {
          return {
            isValid: false,
            message: 'Use "min-max" (e.g., "10-50")',
          };
        }
        if (isNaN(parts[0]) || isNaN(parts[1])) {
          return { isValid: false, message: "Both values must be numbers" };
        }
        if (parseFloat(parts[0]) >= parseFloat(parts[1])) {
          return {
            isValid: false,
            message: "First value must be less than second value",
          };
        }
      } else {
        if (isNaN(value)) {
          return { isValid: false, message: "Value must be a number" };
        }
      }
    }

    return { isValid: true };
  };

  const removeFilterField = (index) => {
    const updated = [...filterFields];
    updated.splice(index, 1);
    setFilterFields(updated);
  };

  const handleFieldChange = (index, key) => {
    const updated = [...filterFields];
    updated[index].key = key;
    setFilterFields(updated);
  };

  const handleValueChange = (index, value) => {
    const updated = [...filterFields];
    updated[index].value = value;
    setFilterFields(updated);
  };

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50); // can be 50 or 100
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);
  const reportOptions = [
    { value: "equipment", label: "Equipment Report" },
    { value: "group", label: "Group Report" },
    { value: "area", label: "Area Report" },
    { value: "custom", label: "Custom Report" },
  ];

  // Visual metadata for the report-type selection cards on the landing screen.
  const reportTypeMeta = {
    equipment: {
      icon: <Boxes size={22} />,
      desc: "Generate a report for specific equipment numbers",
    },
    group: {
      icon: <Group size={22} />,
      desc: "Generate a report by selecting equipment groups",
    },
    area: {
      icon: <MapPin size={22} />,
      desc: "Filter flanges by area name and position range",
    },
    custom: {
      icon: <SlidersHorizontal size={22} />,
      desc: "Build a report with custom field filters",
    },
  };
  useEffect(() => {
    setPageLoading(true);
    setTimeout(() => {
      setPageLoading(false);
    }, 1000);
  }, [])
  useEffect(() => {
    if (showPopup) {
      const selectedProject = JSON.parse(
        localStorage.getItem("selectedProject")
      );
      if (!selectedProject || selectedProject.length === 0) {
        setSnackbarMessage("Project not selected.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
      setLoading(true);

      axiosInstance
        .get(`${API_URL}/get_all_equipment_number`, {
          params: {
            project_selected: selectedProject,
            search: debouncedSearchTerm, // Use debounced value instead
          },
        })
        .then((res) => {
          setEquipmentList(res.data.data);
          console.log("API Response equipment =", res.data);
        })
        .catch((err) => {
          console.error("Failed to fetch equipment list:", err);
          setSnackbarMessage("Failed to fetch equipment list.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        })
        .finally(() => setLoading(false));
    }
  }, [showPopup, debouncedSearchTerm]);

  // ✅ ADD this effect (mirrors the equipment fetch)
  useEffect(() => {
    if (!showGroupPopup) return;

    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    if (!selectedProject || selectedProject.length === 0) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);
    const controller = new AbortController();
    axiosInstance
      .get(`${API_URL}/get_equipment_group`, {
        params: {
          project_selected: selectedProject,
          search: debouncedSearchGroup || "", // backend handles filtering
        },
        signal: controller.signal,
      })
      .then((res) => {
        setGroupList(res.data.data || []);
        // reset select-all state for current result set
        setSelectAllGroups(false);
        // prune any selections that no longer exist in this result set
        const valid = new Set((res.data.data || []).map((g) => g.group_name));
        setSelectedGroups((prev) => prev.filter((name) => valid.has(name)));
      })
      .catch((err) => {
        console.error("Error fetching group list:", err);
        setSnackbarMessage("Failed to load groups.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [showGroupPopup, debouncedSearchGroup]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...reportData].sort((a, b) => {
      const valA = a[key];
      const valB = b[key];

      if (typeof valA === "string") {
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      } else {
        return direction === "asc" ? valA - valB : valB - valA;
      }
    });

    setReportData(sorted);
  };

  const handleReportChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedReport(selectedValue);
    setShowDropdown(false);

    const selectedOption = reportOptions.find(
      (opt) => opt.value === selectedValue
    );
    console.log("selectoption==", selectedOption);

    if (selectedOption) {
      setReportType(selectedOption.value);

      if (selectedOption.value === "equipment") {
        setShowPopup(true);
      } else if (selectedOption.value === "group") {
        handleGroupPopup();
      } else if (selectedOption.value === "area") {
        setShowAreaPopup(true);
      } else if (selectedOption.value === "custom") {
        setShowCustomPopup(true);
      } else {
        setReportSubmitted(true);
      }
    }
  };

  const handleCustomSubmit = async (fromPagination = false) => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    if (!selectedProject) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Validate all filters
    const validFilters = [];

    for (const filter of filterFields) {
      if (!filter.key || !filter.op || !filter.value) {
        setSnackbarMessage(
          "Please complete all filter fields (Field, op, and Value)."
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      // Validate the value format
      const validation = validateFilterValue(
        filter.key,
        filter.op,
        filter.value
      );
      if (!validation.isValid) {
        setSnackbarMessage(
          `Invalid value for ${formatKeyLabel(filter.key)}: ${validation.message}`
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      // Build the filter object for API - adjust this based on your API requirements
      validFilters.push({
        field: filter.key,
        op: filter.op,
        value: filter.value.trim(),
      });
    }

    if (validFilters.length === 0) {
      setSnackbarMessage("Please add at least one valid filter.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      filters: validFilters,
      selected_option: "Custom",
    };

    setIsSubmitting(true);

    try {
      const response = await axiosInstance.post(
        `${API_URL}/get_flange_report`,
        payload,
        {
          params: {
            project_selected: selectedProject,
            page: currentPage,
            per_page: itemsPerPage,
          },
        }
      );

      const rawData = response.data.data || [];

      const normalizedData = rawData.map((item) => {
        return {
          equipmentNumber: item["Equipment_Number"] || "-",
          equipmentName: item["Equipment_Name"] || "-",
          flangeNumber: item["flange_number"],
          unitName: item["unit_name"] || "-",
          boltMaterial: item["bolt_material"] || "-",
          boltSize: item["Bolt_size"] || "-",
          flangeSize: item["flange_size"] || "-",
          rating: item["rating"] || "-",
          torque: item["Torque"] || "-",
          pass1: item["pass1"] || "-",
          pass2: item["pass2"] || "-",
          pass3: item["pass3"] || "-",
          finalCheck: item["final_check"] || "-",
          gapBwFlangeFaces: item["gap_between_faces"] ?? "-",
          torquingTagNo: item["torquing_tag"] || "-",
          acc: "-",
          notAcc: "-",
          date: item["date"] || "-",
          tag: item["tag"] || "-",
          techSign: "-",
          status: item["Status"] || "-",
          warning: item["warning"] || "",
        };
      });

      const pagination = response.data.pagination;
      if (pagination) {
        setTotalRecords(pagination.total_items);
      }

      setReportData(normalizedData);
      setReportSubmitted(true);
      setShowCustomPopup(false);

      // ✅ ONLY SHOW SUCCESS MESSAGE IF NOT FROM PAGINATION
      if (!fromPagination) {
        setSnackbarMessage("Custom report generated successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Failed to fetch custom report:", error);

      if (error.response && error.response.status === 404) {
        setSnackbarMessage(
          "No data found matching your filters. Please try different criteria."
        );
      } else {
        setSnackbarMessage(
          "Failed to load custom report. Please check your filters and try again."
        );
      }

      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGroupPopup = () => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    if (!selectedProject) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setShowGroupPopup(true); // the effect will fetch
    setSearchGroup("");
  };

  const handleAreaSubmit = async (fromPagination = false) => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    if (!searchValue) {
      setSnackbarMessage("❗ Search value is required.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const startNum = Number(positionStart);
    const endNum = Number(positionEnd);
    const hasStart = String(positionStart).trim() !== "";
    const hasEnd = String(positionEnd).trim() !== "";
    const startInvalid = searchType === "contains" && hasStart && startNum <= 0;
    const endInvalid = searchType === "contains" && hasEnd && endNum <= 0;
    const rangeInvalid =
      searchType === "contains" &&
      hasStart &&
      hasEnd &&
      !startInvalid &&
      !endInvalid &&
      endNum < startNum;

    if (startInvalid || endInvalid || rangeInvalid) {
      setSnackbarMessage(
        rangeInvalid
          ? "Position End must be greater than or equal to Position Start."
          : "Position Start/End must be greater than 0."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post(
        `${API_URL}/get_flange_report`,
        {
          selected_option: "Area",
          search_type: searchType,
          position_start: searchType === "contains" ? positionStart : undefined,
          position_end: searchType === "contains" ? positionEnd : undefined,
        },
        {
          params: {
            project_selected: selectedProject,
            search_value: searchValue,
            page: currentPage,
            per_page: itemsPerPage,
          },
        }
      );

      const rawData = response.data.data;

      const normalizedData = rawData.map((item) => ({
        equipmentNumber: item["Equipment_Number"] || "-",
        equipmentName: item["Equipment_Name"] || "-",
        flangeNumber: item["flange_number"],
        unitName: item["unit_name"] || "-",
        boltMaterial: item["bolt_material"] || "-",
        boltSize: item["Bolt_size"] || "-",
        flangeSize: item["flange_size"] || "-",
        rating: item["rating"] || "-",
        torque: item["Torque"] || "-",
        pass1: item["pass1"] || "-",
        pass2: item["pass2"] || "-",
        pass3: item["pass3"] || "-",
        finalCheck: item["final_check"] || "-",
        gapBwFlangeFaces: item["gap_between_faces"] ?? "-",
        torquingTagNo: item["torquing_tag"] || "-",
        acc: "-",
        notAcc: "-",
        date: item["date"] || "-",
        tag: item["tag"] || "-",
        techSign: "-",
        status: item["Status"] || "-",
        warning: item["warning"] || "",
      }));

      const pagination = response.data.pagination;
      if (pagination) {
        setTotalRecords(pagination.total_items);
      }

      setReportData(normalizedData);
      setReportSubmitted(true);
      setShowAreaPopup(false);

      // ✅ ONLY SHOW SUCCESS MESSAGE IF NOT FROM PAGINATION
      if (!fromPagination) {
        setSnackbarMessage("Area report generated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error("Error fetching area report:", err);
      setSnackbarMessage("Failed to load area report.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAreaPositionStartChange = (value) => {
    if (value === "" || /^[0-9]+$/.test(value)) {
      setPositionStart(value);
    }
  };

  const handleAreaPositionEndChange = (value) => {
    if (value === "" || /^[0-9]+$/.test(value)) {
      setPositionEnd(value);
    }
  };

  const areaStartNum = Number(positionStart);
  const areaEndNum = Number(positionEnd);
  const areaHasStart = String(positionStart).trim() !== "";
  const areaHasEnd = String(positionEnd).trim() !== "";
  const areaPositionStartInvalid =
    searchType === "contains" && areaHasStart && areaStartNum <= 0;
  const areaPositionEndInvalid =
    searchType === "contains" && areaHasEnd && areaEndNum <= 0;
  const areaPositionRangeInvalid =
    searchType === "contains" &&
    areaHasStart &&
    areaHasEnd &&
    !areaPositionStartInvalid &&
    !areaPositionEndInvalid &&
    areaEndNum < areaStartNum;
  const isAreaGenerateDisabled =
    isSubmitting ||
    !searchValue.trim() ||
    areaPositionStartInvalid ||
    areaPositionEndInvalid ||
    areaPositionRangeInvalid;

  // Enhanced Close Popup with backtracking
  const handleClosePopup = () => {
    // Reset all popup states
    setShowPopup(false);
    setShowGroupPopup(false);
    setShowAreaPopup(false);
    setShowCustomPopup(false);

    // Reset selections
    setSelectedEquipments([]);
    setSelectedGroups([]);
    setSearchValue("");
    setFilterFields([]);

    // Reset report selection and show dropdown again
    setSelectedReport(null);
    setShowDropdown(true);

    // Reset loading states
    setIsSubmitting(false);
    setLoading(false);
  };

  // const handleCheckboxChange = (value) => {
  //   setSelectedEquipments((prev) =>
  //     prev.includes(value)
  //       ? prev.filter((item) => item !== value)
  //       : [...prev, value]
  //   );
  // };

  const handleCheckboxChange = (value) => {
    setSelectedEquipments((prev) => {
      const updated = prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value];

      // Update selectAll state based on if all filtered items are selected
      const filteredItems = equipmentList.filter((item) =>
        item.equipment_number
          .toLowerCase()
          .includes(searchEquipment.toLowerCase())
      );
      setSelectAll(
        filteredItems.every((item) => updated.includes(item.equipment_number))
      );

      return updated;
    });
  };

  // const handleGroupCheckboxChange = (groupName) => {
  //   setSelectedGroups((prev) => {
  //     if (prev.includes(groupName)) {
  //       return prev.filter((g) => g !== groupName);
  //     } else {
  //       return [...prev, groupName];
  //     }
  //   });
  // };

  const handleGroupCheckboxChange = (groupName) => {
    setSelectedGroups((prev) => {
      const updated = prev.includes(groupName)
        ? prev.filter((g) => g !== groupName)
        : [...prev, groupName];

      const currentNames = groupList.map((g) => g.group_name);
      setSelectAllGroups(
        currentNames.length > 0 &&
        currentNames.every((name) => updated.includes(name))
      );

      return updated;
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleGroupSubmit = async (fromPagination = false) => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

    if (selectedGroups.length === 0) {
      setSnackbarMessage("Please select at least one group.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post(
        `${API_URL}/get_flange_report`,
        {
          selected_option: "Equipment Group",
          selected_groups: selectedGroups,
        },
        {
          params: {
            project_selected: selectedProject,
            page: currentPage,
            per_page: itemsPerPage,
          },
        }
      );

      console.log("Selected Project:", selectedProject);
      console.log("API Response group", response.data);

      const rawData = response.data.data;

      const normalizedData = rawData.map((item) => ({
        equipmentNumber: item["Equipment_Number"] || "-",
        equipmentName: item["Equipment_Name"] || "-",
        flangeNumber: item["flange_number"],
        unitName: item["unit_name"] || "-",
        boltMaterial: item["bolt_material"] || "-",
        boltSize: item["Bolt_size"] || "-",
        flangeSize: item["flange_size"] || "-",
        rating: item["rating"] || "-",
        torque: item["Torque"] || "-",
        pass1: item["pass1"] || "-",
        pass2: item["pass2"] || "-",
        pass3: item["pass3"] || "-",
        finalCheck: item["final_check"] || "-",
        gapBwFlangeFaces: item["gap_between_faces"] ?? "-",
        torquingTagNo: item["torquing_tag"] || "-",
        acc: "-",
        notAcc: "-",
        date: item["date"] || "-",
        tag: item["tag"] || "-",
        techSign: "-",
        status: item["Status"] || "-",
        warning: item["warning"] || "",
      }));

      const pagination = response.data.pagination;
      if (pagination) {
        setTotalRecords(pagination.total_items);
      }

      console.log("✅ Group Report Data:", normalizedData);

      setReportData(normalizedData);
      setReportSubmitted(true);
      setShowGroupPopup(false);

      // ✅ ONLY SHOW SUCCESS MESSAGE IF NOT FROM PAGINATION
      if (!fromPagination) {
        setSnackbarMessage("Group report generated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error("Error fetching group report:", err);
      setSnackbarMessage("Failed to load group report.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (fromPagination = false) => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

    if (selectedEquipments.length === 0) {
      setSnackbarMessage("Please select at least one equipment.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post(
        `${API_URL}/get_flange_report`,
        {
          selected_option: "Equipment Number",
          selected_equipments: selectedEquipments,
        },
        {
          params: {
            project_selected: selectedProject,
            page: currentPage,
            per_page: itemsPerPage,
          },
        }
      );

      const rawData = response.data.data;

      const normalizedData = rawData.map((item) => {
        return {
          equipmentNumber: item["Equipment_Number"] || "-",
          equipmentName: item["Equipment_Name"] || "-",
          flangeNumber: item["flange_number"],
          unitName: item["unit_name"] || "-",
          boltMaterial: item["bolt_material"] || "-",
          boltSize: item["Bolt_size"] || "-",
          flangeSize: item["flange_size"] || "-",
          rating: item["rating"] || "-",
          torque: item["Torque"] || "-",
          pass1: item["pass1"] || "-",
          pass2: item["pass2"] || "-",
          pass3: item["pass3"] || "-",
          finalCheck: item["final_check"] || "-",
          gapBwFlangeFaces: item["gap_between_faces"] ?? "-",
          torquingTagNo: item["torquing_tag"] || "-",
          acc: "-",
          notAcc: "-",
          date: item["date"] || "-",
          tag: item["tag"] || "-",
          techSign: "-",
          status: item["Status"] || "-",
          warning: item["warning"] || "",
        };
      });

      const pagination = response.data.pagination;
      if (pagination) {
        setTotalRecords(pagination.total_items);
      }

      // ✅ ONLY SHOW SUCCESS MESSAGE IF NOT FROM PAGINATION
      if (!fromPagination) {
        setSnackbarMessage("Equipment report generated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }

      setReportData(normalizedData);
      setReportSubmitted(true);
      setShowPopup(false);
    } catch (error) {
      console.error("Failed to fetch report data", error);
      setSnackbarMessage("Failed to load equipment report.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Effect to refetch data when pagination changes (only for submitted reports)
  useEffect(() => {
    if (
      reportSubmitted &&
      reportType === "equipment" &&
      selectedEquipments.length > 0
    ) {
      handleSubmit(true); // ✅ Pass true to indicate from pagination
    } else if (
      reportSubmitted &&
      reportType === "group" &&
      selectedGroups.length > 0
    ) {
      handleGroupSubmit(true); // ✅ Pass true
    } else if (reportSubmitted && reportType === "area" && searchValue) {
      handleAreaSubmit(true); // ✅ Pass true
    } else if (
      reportSubmitted &&
      reportType === "custom" &&
      filterFields.length > 0
    ) {
      handleCustomSubmit(true); // ✅ Pass true
    }
  }, [currentPage, itemsPerPage]);

  const handleCloseEverything = () => {
    setReportSubmitted(false);
    setShowDropdown(true);
    setSelectedReport(null);
    setSelectedEquipments([]);
    setSelectedGroups([]);
    setSearchValue("");
    setFilterFields([]);
    setReportData([]);
    setCurrentPage(1);
    setTotalRecords(0);
  };

  const handleDownloadExcel = async () => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

    if (!selectedProject) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Validation based on report type (mirrors handleDownloadPDF)
    if (reportType === "equipment" && selectedEquipments.length === 0) {
      setSnackbarMessage("No equipment selected for Excel generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "group" && selectedGroups.length === 0) {
      setSnackbarMessage("No groups selected for Excel generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "area" && !searchValue) {
      setSnackbarMessage("Search value is required for Excel generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "custom" && filterFields.length === 0) {
      setSnackbarMessage("No filters applied for Excel generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    setSnackbarMessage("Excel is processing...");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
    setIsSubmitting(true);

    try {
      let endpoint;
      let payload = {};
      let params = { project_selected: selectedProject };

      // Determine endpoint and payload based on report type.
      // All Excel endpoints are standardized on the `/excel` suffix.
      switch (reportType) {
        case "equipment":
          endpoint = `${API_URL}/get_flange_report/equipment_number/excel`;
          payload = {
            selected_equipments: selectedEquipments,
          };
          break;

        case "group":
          endpoint = `${API_URL}/get_flange_report/group/excel`;
          payload = {
            selected_groups: selectedGroups,
          };
          break;

        case "area":
          endpoint = `${API_URL}/get_flange_report/area/excel`;
          params.search_value = searchValue;
          payload = {
            search_type: searchType,
            position_start: searchType === "contains" ? positionStart : undefined,
            position_end: searchType === "contains" ? positionEnd : undefined,
          };
          break;

        case "custom": {
          endpoint = `${API_URL}/get_flange_report/custom/excel`;

          const validFilters = [];
          for (const filter of filterFields) {
            if (!filter.key || !filter.op || !filter.value) {
              setSnackbarMessage("Please complete all filter fields.");
              setSnackbarSeverity("error");
              setSnackbarOpen(true);
              setIsSubmitting(false);
              return;
            }

            validFilters.push({
              field: filter.key,
              op: filter.op,
              value: filter.value.trim(),
            });
          }

          payload = {
            filters: validFilters,
          };
          break;
        }

        default:
          setSnackbarMessage("Invalid report type for Excel generation.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setIsSubmitting(false);
          return;
      }

      // Make API call (expects a binary .xlsx response)
      const response = await axiosInstance.post(endpoint, payload, {
        params: params,
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `flange_report_${reportType}_${new Date()
        .toISOString()
        .split("T")[0]}.xlsx`;
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      // Close the "in progress" snackbar and show success
      setSnackbarOpen(false);
      setTimeout(() => {
        setSnackbarMessage("Excel file downloaded successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }, 300);
    } catch (error) {
      console.error("Excel export failed:", error);
      setSnackbarOpen(false);
      if (error.response && error.response.status === 404) {
        setSnackbarMessage(
          "No data found for Excel generation. Please check your selections."
        );
      } else if (error.response && error.response.status === 400) {
        setSnackbarMessage("Invalid request. Please verify your selections.");
      } else {
        setSnackbarMessage("Failed to download Excel file.");
      }
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownloadPDF = async () => {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

    if (!selectedProject) {
      setSnackbarMessage("Project not selected.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Validation based on report type
    if (reportType === "equipment" && selectedEquipments.length === 0) {
      setSnackbarMessage("No equipment selected for PDF generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "group" && selectedGroups.length === 0) {
      setSnackbarMessage("No groups selected for PDF generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "area" && !searchValue) {
      setSnackbarMessage("Search value is required for PDF generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (reportType === "custom" && filterFields.length === 0) {
      setSnackbarMessage("No filters applied for PDF generation.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    setSnackbarMessage("Report is processing...");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
    setIsSubmitting(true);

    try {
      let response;
      let endpoint;
      let payload = {};
      let params = { project_selected: selectedProject };

      // Determine endpoint and payload based on report type
      switch (reportType) {
        case "equipment":
          endpoint = `${API_URL}/get_flange_report/equipment_number/pdf`;
          payload = {
            selected_equipments: selectedEquipments,
          };
          break;

        case "group":
          endpoint = `${API_URL}/get_flange_report/group/pdf`;
          payload = {
            selected_groups: selectedGroups,
          };
          break;

        case "area":
          endpoint = `${API_URL}/get_flange_report/area/pdf`;
          params.search_value = searchValue;
          payload = {
            search_type: searchType,
            position_start: searchType === "contains" ? positionStart : undefined,
            position_end: searchType === "contains" ? positionEnd : undefined,
          };
          break;

        case "custom":
          endpoint = `${API_URL}/get_flange_report/custom/pdf`;

          const validFilters = [];
          for (const filter of filterFields) {
            if (!filter.key || !filter.op || !filter.value) {
              setSnackbarMessage("Please complete all filter fields.");
              setSnackbarSeverity("error");
              setSnackbarOpen(true);
              setIsSubmitting(false);
              return;
            }

            validFilters.push({
              field: filter.key,
              op: filter.op,
              value: filter.value.trim(),
            });
          }

          payload = {
            filters: validFilters,
          };
          break;

        default:
          setSnackbarMessage("Invalid report type for PDF generation.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setIsSubmitting(false);
          return;
      }

      // Make API call
      response = await axiosInstance.post(endpoint, payload, {
        params: params,
        responseType: 'blob',
      });

      // Create a blob from the PDF data
      const blob = new Blob([response.data], { type: 'application/pdf' });

      // Generate filename with report type and date
      const filename = `flange_report_${reportType}_${new Date().toISOString().split('T')[0]}.pdf`;

      // Create a link element and trigger download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

      // ✅ Close the "in progress" snackbar and show success
      setSnackbarOpen(false);
      setTimeout(() => {
        setSnackbarMessage("PDF downloaded successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }, 300); // Small delay for smooth transition

    } catch (error) {
      console.error("Failed to download PDF:", error);

      // ✅ Close the "in progress" snackbar and show error
      setSnackbarOpen(false);
      setTimeout(() => {
        // More specific error messages
        if (error.response && error.response.status === 404) {
          setSnackbarMessage("No data found for PDF generation. Please check your selections.");
        } else if (error.response && error.response.status === 400) {
          setSnackbarMessage("Invalid request. Please verify your selections.");
        } else {
          setSnackbarMessage("Failed to download PDF. Please try again.");
        }

        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }, 300);

    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
              {pageLoading && (
                  <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backdropFilter: "blur(6px)",
                              background: "rgba(0,0,0,0.3)",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 9999,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                transform: "scale(2)",
                                gap: "10px",
                              }}
                            >
                              <Loader />
                            </div>
                          </div>
              )}
    <div
      className={`table-container ${isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      style={{ padding: "5px 10px", minHeight: "80vh !important", overflow:"hidden" }}
    >
      {showDropdown && (
        <div className="report-landing">
          <div className="report-landing-card">
            <div className="report-landing-icon">
              <TbReport size={"28px"} color="#e1261c" />
            </div>

            <h2 className="report-landing-title">Generate Report</h2>
            <p className="report-landing-subtitle">
              Choose the type of report you want to generate for your project data
            </p>

            <div className="report-type-grid">
              {reportOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className="report-type-card"
                  onClick={() =>
                    handleReportChange({ target: { value: option.value } })
                  }
                >
                  <span className="report-type-card-icon">
                    {reportTypeMeta[option.value]?.icon}
                  </span>
                  <span className="report-type-card-text">
                    <span className="report-type-card-label">{option.label}</span>
                    <span className="report-type-card-desc">
                      {reportTypeMeta[option.value]?.desc}
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Equipment Report Popup */}
      {showPopup && (
        <Dialog
          open={showPopup}
          onClose={handleClosePopup}
          maxWidth="sm"
          fullWidth
          PaperProps={{ className: "report-modal", sx: { borderRadius: "16px" } }}
        >
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            Select Equipment Numbers
          </DialogTitle>

          {/* Search and Select All Row */}
          <Box
            style={{ alignItems: "flex-start" }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 2,
              borderBottom: "1px solid #e5e7eb",
              px: 3,
              pb: 1,
              flexWrap: "nowrap",
            }}
          >
            {/* Search Input - Left Side */}
            <TextField
              sx={{ flex: 1 }}
              variant="outlined"
              size="small"
              placeholder="Search equipment..."
              value={searchEquipment}
              onChange={(e) => {
                setSearchEquipment(e.target.value);
                setSelectAll(false);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loading && searchEquipment !== debouncedSearchTerm && (
                      <CircularProgress size={20} />
                    )}
                  </InputAdornment>
                ),
              }}
            />

            {/* Select All - Right Side */}
            <FormControlLabel
              sx={{ ml: "auto", alignItems: "center", whiteSpace: "nowrap" }}
              control={
                <Checkbox
                  checked={selectAll}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  indeterminate={
                    selectedEquipments.length > 0 &&
                    selectedEquipments.length <
                    equipmentList.filter((item) =>
                      item.equipment_number
                        .toLowerCase()
                        .includes(searchEquipment.toLowerCase())
                    ).length
                  }
                />
              }
              label={
                <Typography sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                  Select All (
                  {
                    equipmentList.filter((item) =>
                      item.equipment_number
                        .toLowerCase()
                        .includes(searchEquipment.toLowerCase())
                    ).length
                  }
                  )
                </Typography>
              }
            />
          </Box>

          <DialogContent>
            {loading ? (
              <Box sx={{ textAlign: "center", p: 2 }}>
                <CircularProgress size={24} />
                <Typography mt={2}>Loading equipment...</Typography>
              </Box>
            ) : equipmentList.length === 0 ? (
              <Typography>No equipment found.</Typography>
            ) : (
              <>
                <Typography
                  variant="body2"
                  sx={{ mb: 2, color: "text.secondary" }}
                >
                  Select one or more equipment numbers to include:
                </Typography>

                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  {equipmentList.map((item) => (
                    <Box
                      key={item.equipment_number}
                      sx={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "10px",
                        p: 2,
                        mb: 1.5,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedEquipments.includes(
                              item.equipment_number
                            )}
                            onChange={() =>
                              handleCheckboxChange(item.equipment_number)
                            }
                          />
                        }
                        label={
                          <Typography sx={{ fontWeight: 600 }}>
                            Equipment No. {item.equipment_number}
                          </Typography>
                        }
                      />
                    </Box>
                  ))}
                </Box>

                {/* Show message when no results found */}
                {equipmentList.length === 0 && !loading && (
                  <Box sx={{ textAlign: "center", py: 2 }}>
                    <Typography color="text.secondary">
                      No equipment numbers found matching your search
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button variant="outlined" onClick={handleClosePopup}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isSubmitting || selectedEquipments.length === 0}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={16} sx={{ mr: 1 }} /> Generating...
                </>
              ) : (
                `Generate (${selectedEquipments.length} selected) Report`
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Custom Report Popup */}
      {showCustomPopup && (
        <Dialog
          open={showCustomPopup}
          onClose={handleClosePopup}
          maxWidth="md"
          fullWidth
          PaperProps={{ className: "report-modal", sx: { borderRadius: "16px" } }}
        >
          <DialogTitle>Custom Report Filters</DialogTitle>
          <DialogContent className="pt-3">
            {filterFields.map((filter, index) => (
              <Box
                key={index}
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                gap={2}
                mb={"16px"}
                alignItems="flex-end"
                sx={{
                  padding: "12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  // backgroundColor: "#fafafa",
                }}
              >
                {/* Field Selection */}
                <TextField
                  select
                  fullWidth
                  label="Select Field"
                  value={filter.key}
                  onChange={(e) => {
                    handleFieldChange(index, e.target.value);
                    // Reset op and value when field changes
                    const updated = [...filterFields];
                    updated[index].op = "";
                    updated[index].value = "";
                    setFilterFields(updated);
                  }}
                  sx={{ minWidth: 200 }}
                >
                  {fieldDefinitions.map((field) => (
                    <MenuItem key={field.key} value={field.key}>
                      {formatKeyLabel(field.key)}
                    </MenuItem>
                  ))}
                </TextField>
                {/* op Selection */}
                <TextField
                  select
                  fullWidth
                  label="Operator"
                  value={filter.op}
                  onChange={(e) => handleopChange(index, e.target.value)}
                  disabled={!filter.key}
                  sx={{ minWidth: 180 }}
                >
                  {getOpsForField(filter.key).map((op) => (
                    <MenuItem key={op} value={op}>
                      {getOperatorLabel(op)}
                    </MenuItem>
                  ))}
                </TextField>
                {/* Value Input */}
                {(() => {
                  const def = getFieldDefinition(filter.key);
                  const isNumber = def?.dataType === "number";
                  const isBetween = filter.op === "between";

                  const label = isBetween
                    ? "Value (min-max)"
                    : isNumber
                      ? "Value (number)"
                      : "Value";

                  const placeholder = isBetween
                    ? "10-50"
                    : isNumber
                      ? "123"
                      : "text";

                  const helperText = isBetween
                    ? "Format: minimum-maximum (e.g., 10-50)"
                    : isNumber
                      ? "Enter a numeric value"
                      : "";

                  return (
                    <TextField
                      fullWidth
                      label={label}
                      value={filter.value}
                      onChange={(e) => handleValueChange(index, e.target.value)}
                      disabled={!filter.op}
                      placeholder={placeholder}
                      helperText={helperText}
                      sx={{ minWidth: 200 }}
                    />
                  );
                })()}
                {/* Remove Button */}
                {filterFields.length > 1 && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => removeFilterField(index)}
                    sx={{
                      height: "56px",
                      whiteSpace: "nowrap",
                      mb: { xs: 0, sm: "auto" },
                      minWidth: 100,
                    }}
                  >
                    REMOVE
                  </Button>
                )}
              </Box>
            ))}

            <Button
              variant="outlined"
              onClick={addFilterField}
              fullWidth
              sx={{ mb: 2 }}
            >
              + ADD FILTER
            </Button>

            {/* Filter Summary */}
            {filterFields.length > 0 &&
              filterFields.some((f) => f.key && f.op && f.value) && (
                <Box
                  mt={2}
                  p={2}
                  border="1px solid #ddd"
                  borderRadius={2}
                  sx={{ backgroundColor: "#f8f9fa" }}
                >
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Filter Summary
                  </Typography>
                  {filterFields
                    .filter((f) => f.key && f.op && f.value)
                    .map((f, i) => {
                      const opLabel = getOperatorLabel(f.op);
                      return (
                        <Typography key={i} variant="body2" sx={{ mb: 0.5 }}>
                          <strong>{formatKeyLabel(f.key)}</strong> {opLabel}{" "}
                          <strong>{f.value}</strong>
                        </Typography>
                      );
                    })}
                </Box>
              )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleClosePopup}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleCustomSubmit}
              disabled={
                isSubmitting ||
                filterFields.length === 0 ||
                filterFields.some((f) => !f.key || !f.op || !f.value)
              }
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={16} sx={{ mr: 1 }} /> Generating...
                </>
              ) : (
                "Generate Report"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Group Report Popup */}
      {showGroupPopup && (
        <Dialog
          open={showGroupPopup}
          onClose={handleClosePopup}
          maxWidth="sm"
          fullWidth
          PaperProps={{ className: "report-modal", sx: { borderRadius: "16px" } }}
        >
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            Select Equipment Groups
          </DialogTitle>

          {/* Search and Select All Row */}
          <Box
            style={{ alignItems: "flex-start" }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 0,
              borderBottom: "1px solid #e5e7eb",
              px: 3,
              pb: 2,
            }}
          >
            {/* Search Input - Left Side */}
            <TextField
              sx={{ flex: 1 }}
              variant="outlined"
              size="small"
              placeholder="Search groups..."
              value={searchGroup}
              onChange={(e) => {
                setSearchGroup(e.target.value);
                setSelectAllGroups(false);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loading && searchGroup !== debouncedSearchGroup && (
                      <CircularProgress size={20} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            {/* Select All - Right Side */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectAllGroups}
                  onChange={(e) => handleSelectAllGroups(e.target.checked)}
                  indeterminate={
                    selectedGroups.length > 0 &&
                    selectedGroups.length < groupList.length
                  }
                />
              }
              label={
                <Typography sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                  Select All ({groupList.length})
                </Typography>
              }
            />
          </Box>

          <DialogContent>
            {loading ? (
              <Box sx={{ textAlign: "center", p: 2 }}>
                <CircularProgress size={24} />
                <Typography mt={2}>Loading equipment groups...</Typography>
              </Box>
            ) : groupList.length === 0 ? (
              <Typography>No groups found.</Typography>
            ) : (
              <>
                <Typography
                  variant="body2"
                  sx={{ mb: 2, color: "text.secondary" }}
                >
                  Select one or more equipment groups:
                </Typography>

                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                  {groupList.map((group) => (
                    <Box
                      key={group.group_name}
                      sx={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "10px",
                        p: 2,
                        mb: 1.5,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedGroups.includes(group.group_name)}
                            onChange={() =>
                              handleGroupCheckboxChange(group.group_name)
                            }
                          />
                        }
                        label={
                          <Typography sx={{ fontWeight: 600 }}>
                            {group.group_name}
                          </Typography>
                        }
                      />
                    </Box>
                  ))}
                </Box>

                {/* Show message when no results found */}
                {groupList.length === 0 && (
                  <Box sx={{ textAlign: "center", py: 2 }}>
                    <Typography color="text.secondary">
                      No groups found matching your search
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button variant="outlined" onClick={handleClosePopup}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleGroupSubmit}
              disabled={isSubmitting || selectedGroups.length === 0}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={16} sx={{ mr: 1 }} /> Generating...
                </>
              ) : (
                `Generate (${selectedGroups.length} selected) Report`
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Area Report Popup */}
      {showAreaPopup && (
        <Dialog
          open={showAreaPopup}
          onClose={handleClosePopup}
          maxWidth={false}
          fullWidth={false}
          PaperProps={{ className: "area-report-modal-paper" }}
        >
          <DialogTitle className="area-report-modal-title">
            Area Report Search
          </DialogTitle>
          <DialogContent className="area-report-modal-body">
            <Typography className="area-report-modal-subtitle">
              Configure search parameters for area-based filtering.
            </Typography>

            <FormControl fullWidth margin="normal" className="area-report-field">
              <InputLabel>Search Type</InputLabel>
              <Select
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
                label="Search Type"
                className="area-report-select"
              >
                <MenuItem value="contains">Contains</MenuItem>
                <MenuItem value="starts_with">Starts With</MenuItem>
                <MenuItem value="ends_with">Ends With</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              className="area-report-field"
              label="Search Value"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Enter search text"
              helperText="Enter the text to search for in the area field"
              FormHelperTextProps={{ className: "area-report-help" }}
            />

            {searchType === "contains" && (
              <>
                <TextField
                  fullWidth
                  margin="normal"
                  className="area-report-field"
                  label="Position Start (Optional)"
                  value={positionStart || ""}
                  onChange={(e) => handleAreaPositionStartChange(e.target.value)}
                  placeholder="Starting position"
                  error={areaPositionStartInvalid}
                  helperText={
                    areaPositionStartInvalid
                      ? "Position Start must be greater than 0"
                      : " "
                  }
                  FormHelperTextProps={{ className: "area-report-help" }}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  className="area-report-field"
                  label="Position End (Optional)"
                  value={positionEnd || ""}
                  onChange={(e) => handleAreaPositionEndChange(e.target.value)}
                  placeholder="Ending position"
                  error={areaPositionEndInvalid || areaPositionRangeInvalid}
                  helperText={
                    areaPositionEndInvalid
                      ? "Position End must be greater than 0"
                      : areaPositionRangeInvalid
                        ? "Position End must be greater than or equal to Position Start"
                        : " "
                  }
                  FormHelperTextProps={{ className: "area-report-help" }}
                />
              </>
            )}
          </DialogContent>

          <DialogActions className="area-report-modal-footer">
            <Button className="area-report-cancel-btn" onClick={handleClosePopup}>
              Cancel
            </Button>
            <Button
              className="area-report-apply-btn"
              variant="contained"
              onClick={handleAreaSubmit}
              disabled={isAreaGenerateDisabled}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={16} sx={{ mr: 1 }} /> Generating...
                </>
              ) : (
                "Generate Report"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Report Results Table */}
      {reportSubmitted &&
        Array.isArray(reportData) &&
        reportData.length > 0 && (
          <>
            <div className="report-results-header">
              <div className="report-results-titleblock">
                <h2 className="page-title mb-0">
                  {reportOptions.find((o) => o.value === reportType)?.label ||
                    "Report"}
                </h2>
                <span className="report-results-count">
                  {totalRecords} {totalRecords === 1 ? "record" : "records"}
                </span>
              </div>

              <div className="report-actions">
                <button
                  className="btn-report-action btn-report-pdf d-flex justify-content-center align-items-center"
                  onClick={handleDownloadPDF}
                  disabled={
                    (reportType === "equipment" && selectedEquipments.length === 0) ||
                    (reportType === "group" && selectedGroups.length === 0) ||
                    (reportType === "area" && !searchValue) ||
                    (reportType === "custom" && filterFields.length === 0)
                  }
                >
                  <TbReportAnalytics fontSize={17} className="me-1" />
                  Download PDF
                </button>

                <button
                  className="btn-report-action btn-report-excel d-flex justify-content-center align-items-center"
                  onClick={handleDownloadExcel}
                  disabled={
                    (reportType === "equipment" && selectedEquipments.length === 0) ||
                    (reportType === "group" && selectedGroups.length === 0) ||
                    (reportType === "area" && !searchValue) ||
                    (reportType === "custom" && filterFields.length === 0)
                  }
                >
                  <RiFileExcel2Line fontSize={17} className="me-1" />
                  Download Excel
                </button>

                <button
                  className="btn-report-action btn-report-close d-flex justify-content-center align-items-center"
                  onClick={handleCloseEverything}
                >
                  <IoClose fontSize={20} className="me-1" />
                  Close
                </button>
              </div>
            </div>

            <Box
              sx={{
                height: "calc(100vh - 150px)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="report-results-card">
              {/* Table Scrollable Area */}
              <TableContainer
                component={Paper}
                className="report-results-table"
                sx={{ flex: 1, overflowY: "auto" }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr.No</TableCell>
                      <TableCell>Flange Number</TableCell>
                      <TableCell>Tag No. / Equipment No.</TableCell>
                      {/* <TableCell>Equipment No</TableCell> */}
                      <TableCell>Equipment Name</TableCell>
                      <TableCell>Unit Name</TableCell>
                      <TableCell>Bolt Material</TableCell>
                      <TableCell>Bolt Size</TableCell>
                      <TableCell>Flange Size</TableCell>
                      <TableCell>Rating</TableCell>
                      <TableCell>Torque Value (Nm)</TableCell>
                      <TableCell>Pass1 (30%)</TableCell>
                      <TableCell>Pass2 (60%)</TableCell>
                      <TableCell>Pass3 (100%)</TableCell>
                      <TableCell>Final Check</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>GAP B/W Flange Faces</TableCell>
                      <TableCell>Torquing Tag No</TableCell>
                      <TableCell>ACC</TableCell>
                      <TableCell>Not ACC</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Tech Sign</TableCell>
                      <TableCell>Remarks</TableCell>
                      
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportData.map((row, index) => {
                      const hasWarning = row.warning?.trim() !== "";
                      const globalIndex =
                        (currentPage - 1) * itemsPerPage + index + 1;

                      return (
                        <TableRow
                          key={index}
                          className={hasWarning ? "report-row-warning" : ""}
                          sx={{
                            cursor: hasWarning ? "help" : "default",
                          }}
                        >
                          <TableCell>{globalIndex}</TableCell>
                          <TableCell>{row.flangeNumber}</TableCell>
                          <TableCell sx={{ minWidth: "100px" }}>
                            {row.tag}
                          </TableCell>
                          {/* <TableCell>{row.equipmentNumber}</TableCell> */}
                          <TableCell>{row.equipmentName}</TableCell>
                          <TableCell>{row.unitName}</TableCell>
                          <TableCell>{row.boltMaterial}</TableCell>
                          <TableCell>{row.boltSize}</TableCell>
                          <TableCell>{row.flangeSize}</TableCell>
                          <TableCell>{row.rating}</TableCell>
                          <TableCell>{row.torque}</TableCell>
                          <TableCell>{row.pass1}</TableCell>
                          <TableCell>{row.pass2}</TableCell>
                          <TableCell>{row.pass3}</TableCell>
                          <TableCell>
                            {row.finalCheck}
                            {hasWarning && (
                              <Tooltip title={row.warning}>
                                <span
                                  style={{
                                    color: "#b91c1c",
                                    marginLeft: "4px",
                                  }}
                                >
                                  ⚠️
                                </span>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell>{row.status}</TableCell>
                          <TableCell>{row.gapBwFlangeFaces ?? "-"}</TableCell>
                          <TableCell>{row.torquingTagNo ?? "-"}</TableCell>
                          <TableCell>{row.acc ?? "-"}</TableCell>
                          <TableCell>{row.notAcc ?? "-"}</TableCell>
                          <TableCell>
                            {row.date ?? "-"}
                          </TableCell>
                          <TableCell>{row.techSign ?? "-"}</TableCell>
                          <TableCell>{row.remarks ?? "-"}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Footer Pagination — shared component for app-wide consistency */}
              <PaginationFooter
                totalRecords={totalRecords}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
              </div>
            </Box>
          </>
        )}

      {/* No Data Message */}
      {reportSubmitted && reportData.length === 0 && !isSubmitting && (
        <div className="report-empty">
          <div className="report-empty-card">
            <div className="report-empty-icon">
              <AlertTriangle size={28} />
            </div>
            <h3 className="report-empty-title">No Data Found</h3>
            <p className="report-empty-subtitle">
              No records match your selected criteria. Try adjusting your
              filters or generating a different report.
            </p>
            <button
              className="report-empty-btn"
              onClick={handleCloseEverything}
            >
              Generate New Report
            </button>
          </div>
        </div>
      )}

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
    </div>
  );
}

export default AllTags;
